import React from 'react';
import PropTypes from 'prop-types';

export default class extends React.Component {
  static contextTypes = {
    formatters: PropTypes.object
  };

  render() {
    const { formatters } = this.context;
    const { donated, goal, progress } = this.props;

    return (
      <div className="donation__cfloating-padding">
        <div className="donation__price -primary-color">
          {Number.isInteger(donated) ? formatters.formatCurrency(donated, '€', 0) : formatters.formatCurrency(donated, '€', 2)}
        </div>

        <div className="progressbar">
          <div className="progressbar__line">
            <div className="progressbar__em -primary-bg" style={{ width: `${progress}%` }} />
          </div>

          <div className="progressbar__legend">
            <span className="-primary-color">{formatters.formatNumber(progress, 0)} %</span>
            <span>{formatters.formatCurrency(goal, '€', 0)}</span>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/donation/DonationCounter.js